import {inputFileCardController} from "./elements.file.card.module";
import {MoeFileItem}  from "./../../core/fileitem"
import {fioFull} from "./../../app.filters";


class inputFileYandexController extends inputFileCardController{
    static get $inject(){ return   [
        "$element", 
        "UniqueIdService", 
        '$scope', 
        'DialogService', 
        '$log', 
        'BXDataService',
        '$sce'
    ]}

    constructor($element, UniqueIdService, $scope, DialogService, $log, BXDataService, $sce) {
        super($element, UniqueIdService, $scope, DialogService, $log);
        this.yamapIsShow = false;
        this.yamapModel = {};
        this.isYaMapInited = false;
        this.$element = $element;
        this.BXData = BXDataService;
        this.$sce = $sce;
    } 

    AsHtml(html){

        return this.$sce.trustAsHtml(html);
    }



    yaMap(){
        this.yamapIsShow = true;
    }
    allowYamap(){
        this.isYaMapInited = true;
        this.redraw();
    }
    uploadYamap(data){
      
        const form = $(this.$element).closest('form');
    
        data.bxu_info ={
            CID:this.model.Cid
        };

        data.cid  =this.model.Cid;

        form.find('input[type="hidden"]').each((iter,element) => {
            data[element.name] = element.value;
        });
        

        let name = '';

        switch(this.bid.CategoryClient){
            case 'ul':
                name = this.bid.Organization.NameShort;
            break;
            case 'ip':
                name =fioFull()(this.bid.IndividualEntrepreneur);
            break;
            case 'fl':
                name =fioFull()(this.bid.Individual);
            break;

        }

        data.name = name;
        data.RefNum =this.bid.ObjectTP.ReferenceNumber?this.bid.ObjectTP.ReferenceNumber:'---';
        data.CadastralNum=this.bid.ObjectTP.CadastralNumber?this.bid.ObjectTP.CadastralNumber:'---';
        
        try {
            
            this.bid.CoordinatesObjectList = data.points.map((points,index)=>{
                return {
                    Latitude: points[1], 
                    Longitude: points[0], 
                    Number: index+1
                }
            })

            this.bid.CoordinatesVRU = [{
                Latitude: data.vru[1],
                Longitude: data.vru[0],
            }];
        } catch (error) {
                console.error('unable save yad points ', {
                    points:data.points,
                    vru:data.vru
                });
        }
  
    
       
        
        /*
         vru: Array(2)
        0: 37.619999999999976
        1: 55.749999999993705
                
                
                2: Array(2)
        0: 37.62108361244199
        1: 55.75039695222726

        CoordinatesObjectList: [
            {Latitude: 0}, {Latitude: 55.908718637065, Longitude: 36.752634268671, Number: 3},…
        ]

        CoordinatesVRU: [{Latitude: 55.908761836434856, Longitude: 36.75313852396763}]
      
        
        */

        this.BXData.createYadFile(data).then(
            (data)=>{
                
                var file = data.data ; 


                var item =  MoeFileItem.create('fileyad123456',
                    {
                        name: file.fileName,
                        size:  file.fileSize, //parseInt(file['~fileSize']),
                        fileId:  parseInt(file.fileID),
                        valueId: 0,
                        viewUrl: file.fileURL,
                        deleteUrl: file.fileURLDelete,
                        progress:  0
                    }
                );
        
                item.setLoaded(file.fileURL);
                this._items.push(item);
                this.model.Files.push( {
                    Name: file.fileName, 
                    Size: parseInt(file['~fileSize']),
                    FileId: parseInt(file.fileID),
                    ViewUrl: file.fileURL,
                })
              

                                    
            },
            (data)=>{
                console.log('error response yad', data);
                            
            },
        );
        /*
            entity bid 
            sid
            mode upload-yad
            sign

         */
        
    }
     
}

export {inputFileYandexController};


// WEBPACK FOOTER //
// ./src/components/elements/elements.file.yandex.module.js